import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import icon from '../assets/icon-clear.png';
import './navbar.css';

const Navbar = ({ selected }) => {
  const navigate = useNavigate();
  const [visibleLinks, setVisibleLinks] = useState([]);
  
  const allLinks = [
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Databases', href: '/databases' },
    { name: 'CRM', href: '/crm' },
    { name: 'Pricing Engine', href: '/pricing-engine' },
    { name: 'Legal', href: '/legal' },
    { name: 'Maintenance', href: '/maintenance' },
    { name: 'Financial', href: '/financial' },
    { name: 'Reporting', href: '/reporting' },
    { name: 'Admin', href: '/admin' },
  ];

  useEffect(() => {
    // Check if user is a manager/employee
    const userType = localStorage.getItem('userType');
    if (userType !== 'manager') {
      // For tenants, show no links (they use tenant portal)
      setVisibleLinks([]);
      return;
    }

    // Get permissions from localStorage
    const permissionsStr = localStorage.getItem('permissions');
    if (permissionsStr) {
      try {
        const permissions = JSON.parse(permissionsStr);
        const allowedTabs = permissions.tabs || [];
        
        // Filter links based on permissions
        const filtered = allLinks.filter(link => {
          // Always show Dashboard
          if (link.name === 'Dashboard') return true;
          // Check if tab is in allowed tabs
          return allowedTabs.includes(link.name);
        });
        
        setVisibleLinks(filtered);
      } catch (e) {
        // If permissions parsing fails, show all links (fallback)
        setVisibleLinks(allLinks);
      }
    } else {
      // No permissions set, show all links (fallback for existing users)
      setVisibleLinks(allLinks);
    }
  }, []);
  
  const links = visibleLinks.length > 0 ? visibleLinks : allLinks;

  const handleLinkClick = (e, href) => {
    e.preventDefault();
    navigate(href);
  };

  const handleLogout = async () => {
    try {
      // Call logout endpoint
      const response = await fetch(`${API_BASE_URL}/api/logout`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
      
      if (response.ok) {
        // Clear localStorage
        localStorage.removeItem('authenticated');
        localStorage.removeItem('username');
        localStorage.removeItem('lastActivity');
        
        // Redirect to login page
        navigate('/');
      }
    } catch (error) {
      console.error('Logout error:', error);
      // Even if the API call fails, clear localStorage and redirect
      localStorage.removeItem('authenticated');
      localStorage.removeItem('username');
      localStorage.removeItem('lastActivity');
      navigate('/');
    }
  };

  return (
    <nav className="navbar">
      <img src={icon} alt="Logo" className="logo-nav" />

      <div className="nav-center">
        <div className="navlinks">
          {links.map(link => (
            <a
              key={link.name}
              href={link.href}
              onClick={(e) => handleLinkClick(e, link.href)}
              className={selected === link.name ? 'selected' : ''}
            >
              {link.name}
            </a>
          ))}
        </div>
      </div>

      <div className="nav-right">
        <input type="text" className="search-nav" placeholder="🔍 Search" />
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </div>
    </nav>
  );
};

export default Navbar;
